export default "__VITE_ASSET__BOCF$I$X__"